import posthog from 'posthog-js';
import { isLocal, isOnline } from '@/const/env';
import { useUserStore } from '@/stores/user';
import { PosthogController } from './helper';

class PosthogModule {
  private controller = new PosthogController(
    posthog,
    error => console.error('[PostHog]', error),
    {
      loaded: (posthogInstance: typeof posthog) => {
        if (isLocal) {
          posthogInstance.debug();
        }
      },
    },
  );

  initializeAnonymousUser(anonymousUserId: string | null) {
    this.controller.initializeAnonymousUser(anonymousUserId, this.getConfig());
  }

  identifyCurrentUser() {
    const userInfo = useUserStore.getState().getUserInfo();

    if (!userInfo?.userId) {
      return;
    }

    const userSubscription = useUserStore.getState().userSubscription;
    this.controller.identifyAuthenticatedUser(
      userInfo.userId,
      {
        name: userInfo.userName,
        email: userInfo.email,
        plan: userSubscription?.currentProduct?.name,
        environment: isOnline ? 'production' : 'development',
      },
      this.getConfig(),
    );
  }

  reset() {
    this.controller.reset();
  }

  private getConfig() {
    return {
      token: import.meta.env.PUBLIC_POSTHOG_KEY,
      apiHost: import.meta.env.PUBLIC_POSTHOG_HOST,
    };
  }
}

const posthogModule = new PosthogModule();

export default posthogModule;
